import script from "./Ydcs.vue?vue&type=script&setup=true&lang=js"
export * from "./Ydcs.vue?vue&type=script&setup=true&lang=js"

import "./Ydcs.vue?vue&type=style&index=0&id=143234d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-143234d6"]])

export default __exports__